export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_DUPLICATE = 'REGISTER_DUPLICATE';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export const REGISTER_LODING = 'REGISTER_LODING';
export const REGISTER_COMPLETE = 'REGISTER_COMPLETE';
export const SINGUP_COMPLETE_REQUEST = 'SINGUP_COMPLETE_REQUEST';
export const SINGUP_COMPLETE_SUCCESS = 'SINGUP_COMPLETE_SUCCESS';
export const SINGUP_COMPLETE_FAILURE = 'SINGUP_COMPLETE_FAILURE';
